/**
 * frontend/src/pages/valuation/_nextStep.ts
 *
 * VAL-PATH-ROUTES (P1) — "what should this person do next with this
 * engagement" is now the current step of the one step list (_steps.ts): the
 * first step not done, for this role, read from the server summary fields
 * only. The dashboard card, the History row, the left nav and the step bar
 * all ask here, so they name the same step. The earlier gate-order answer
 * (VAL-ACTOR-JOURNEY-1-SIGNER R2) and its session-run lookup are retired.
 */
import type { ValuationEngagement } from '@/types/valuation'
import { currentStep, type PathStepKey } from './_steps'

export type ChipKind = 'sign' | 'intake' | 'view'

export interface NextStep {
  key: PathStepKey
  label: string
  route: string
  kind: ChipKind
}

export function nextStep(engagement: ValuationEngagement, role: string | undefined): NextStep {
  const id = engagement.valuation_engagement_id
  const step = currentStep(engagement, role)
  const kind: ChipKind = engagement.status === 'signed_off' ? 'view' : step.key === 'signoff' ? 'sign' : 'intake'
  return { key: step.key, label: step.label, route: step.route(id), kind }
}
